import {isNodeEmpty} from '@tiptap/core';

import {type EditorState} from 'prosemirror-state';

import {type Schema} from 'prosemirror-model';

import {getMarkdownSerializer, cleanMarkdown} from './utils';

export function toMarkdown(state: EditorState, schema: Schema): string {
    const serializer = getMarkdownSerializer(schema);

    if (isNodeEmpty(state.doc)) {
        return '';
    }

    const mdContent = serializer.serialize(state.doc, {
        tightLists: false,
    });

    return cleanMarkdown(mdContent);
}
